import { render, staticRenderFns } from "./attrList.vue?vue&type=template&id=5039760d&scoped=true&"
import script from "./attrList.vue?vue&type=script&lang=js&"
export * from "./attrList.vue?vue&type=script&lang=js&"
import style0 from "./attrList.vue?vue&type=style&index=0&id=5039760d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039760d",
  null
  
)

export default component.exports